import { createAsyncThunk } from '@reduxjs/toolkit';
import patchClockOutAllowanceRecord from '../services/clockOutAllowanceRecord.service';

export const clockOutAllowanceRecord = createAsyncThunk(
  'records/clockOutAllowanceRecord',
  async (recordId) => {
    const updatedRecord = await patchClockOutAllowanceRecord(recordId);
    return updatedRecord;
  }
);
